import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import { Navigate, useLocation } from 'react-router-dom';

import { userAtom } from '../utils/store';

import { useValidateUser } from './useValidateUser';
import { useInactivity } from './useInactivity';

interface ComponentProp {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ComponentProp) => {
  const user = useAtomValue(userAtom);
  const location = useLocation();
  useInactivity(!!user);

  const { isLoading } = useValidateUser();

  if (isLoading) {
    return <Spin />;
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
